// This file is used for maintain and manage API services
(function () {
  'use strict';
  angular.module('obex').
  factory('allowIntegrations', ['$http', '$q', 'obexConstant', 'authService',
    ($http, $q, obexConstant, authService) => {
      return {
        getAllowIntegrationsByOrganizationId(organizationId) {          
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAllowIntegrations}/organization/id/${organizationId}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        getAllowIntegrationById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAllowIntegrations}/id/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        addAllowIntegration(AllowIntegration) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAllowIntegrations}`;
            const postData = {              
              OrganizationId: AllowIntegration.OrganizationId,
              Allowed: AllowIntegration.Allowed,
              CategoryApp: AllowIntegration.CategoryApp
            };
            return $http.post(url, postData, {
              headers: authHeader,
            });
          });
        }, 

        updateAllowIntegration(id, AllowIntegration) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAllowIntegrations}/id/${id}`;
            const putData = {
              Id: AllowIntegration.Id,
              OrganizationId: AllowIntegration.OrganizationId,
              Allowed: AllowIntegration.Allowed,
              CategoryApp: AllowIntegration.CategoryApp,
            };
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },

        deleteAllowIntegration(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAllowIntegrations}/id/${id}`;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },        
      };
    },
  ]);
})();



// WEBPACK FOOTER //
// ./client/js/services/allowIntegrations.service.js